<template>
  <v-snackbar :timeout="timeout" :color="type" bottom right v-model="show" @click.native="close">
    {{ message }}
  </v-snackbar>
</template>

<script>
import notifications from '../../utils/notifications';

export default {
  name: 'notifications',
  data() {
    return {
      show: false,
      timeout: 5000,
      delay: 250,
      type: '',
      message: '',
      queue: [],
      current: null,
    };
  },
  mounted() {
    const types = ['info', 'success', 'error', 'warning'];

    types.forEach((type) => {
      notifications.$on(type, this.createListener(type));
    });
  },
  methods: {
    createListener(type) {
      return (message, timeout = 3500) => {
        if (!this.current) {
          this.showMessage({ type, message, timeout });
        } else {
          this.queue.push({ type, message, timeout });
        }
      };
    },
    showMessage({ type, message, timeout }) {
      this.type = type;
      this.message = message;
      this.timeout = timeout;

      this.show = true;

      this.current = setTimeout(() => {
        if (this.queue.length > 0) {
          this.showMessage(this.queue.shift());
        } else {
          this.current = null;
        }
      }, timeout + this.delay);
    },
    close() {
      this.show = false;

      if (this.current) {
        clearTimeout(this.current);
        this.current = null;
      }

      if (this.queue.length > 0) {
        setTimeout(() => {
          this.showMessage(this.queue.shift());
        }, this.delay);
      }
    },
  },
};
</script>

<style scoped>
.snack {
  cursor: pointer;
}
</style>
